export const TABS_SPEED: Record<string, number> = {
  slow: 15000,
  medium: 10000,
  fast: 5000,
};
